import rentObjectPromotionsService from "@/services/rentObjectPromotionsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await rentObjectPromotionsService.create(formData);
      dispatch(
        "common/showSuccess",
        "Angebots-Objekt wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebots-Objekt konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await rentObjectPromotionsService.findAll(formData);
      commit("setAllPromotions", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebots-Objekten konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectPromotionsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Angebots-Objekt wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebots-Objekt konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAllPromotions(state, object) {
    state.all = object;
  },
  setSinglePromotion(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
